var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegram({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.10355 6.48176C1.10355 6.48176 9.06452 3.21457 11.8255 2.06412C12.8839 1.60397 16.4733 0.131382 16.4733 0.131382C16.4733 0.131382 18.1299 -0.51282 17.9918 1.05173C17.9458 1.696 17.5777 3.9508 17.2095 6.38973C16.6573 9.84104 16.0591 13.6144 16.0591 13.6144C16.0591 13.6144 15.9671 14.6728 15.1848 14.8569C14.4025 15.041 13.114 14.2127 12.8839 14.0286C12.6998 13.8906 9.43263 11.8198 8.2362 10.8074C7.91406 10.5313 7.54595 9.97911 8.28218 9.33485C9.93882 7.81627 11.9175 5.92959 13.114 4.73315C13.6662 4.18091 14.2184 2.89244 11.9175 4.45699C8.65036 6.71186 5.42916 8.82865 5.42916 8.82865C5.42916 8.82865 4.69286 9.2888 3.31237 8.87464C1.93181 8.46054 0.321209 7.9083 0.321209 7.9083C0.321209 7.9083 -0.783137 7.21805 1.10355 6.48176Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.02ff1532db084612644b83f562280f05.svg";
export { ForwardRef as ReactComponent };